export default function downloadFileInBackground(url, cleanUpFunc) {
  const a = document.createElement('a')
  a.href = url
  document.body.appendChild(a)
  a.click()
  setTimeout(function() {
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)

    if (typeof cleanUpFunc === 'function') {
      cleanUpFunc()
    }
  }, 1000)
}
